import { Component, Inject, PLATFORM_ID } from '@angular/core';
import { CommonModule } from '@angular/common';
import {MatSelectChange, MatSelectModule} from '@angular/material/select';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import {MatInputModule} from '@angular/material/input';
import {MatFormFieldModule} from '@angular/material/form-field';
import { EncryptionService } from 'src/app/service/encryption.service';
import { HttpClient } from '@angular/common/http';
import { APP_SETTINGS, AppSettings } from 'src/app/settings';
import { ForumApiService } from 'src/app/service/forum.api.service';
import { StorageService } from 'src/app/service/storage.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { Meta, Title } from '@angular/platform-browser';
import {
  MatBottomSheet
} from '@angular/material/bottom-sheet';
import { MatBottomSheetRef} from '@angular/material/bottom-sheet';  

import { BottomsheetModalComponent } from '../bottomsheet-modal/bottomsheet-modal.component';
import { isPlatformBrowser } from '@angular/common';
import { GlobalValueService } from 'src/app/service/globalValue.service.';
import { DataService } from 'src/app/service/data.service';
import { ConstantService } from 'src/app/service/constant.service';

@Component({
  selector: 'app-create-ticket-form',
  standalone: true,
  imports: [MatFormFieldModule, MatInputModule, MatSelectModule, CommonModule, ReactiveFormsModule],
  templateUrl: './create-ticket-form.component.html',
  styleUrls: ['./create-ticket-form.component.less']
})

export class CreateTicketFormComponent {
  
  faqArray = [];
  childArray = [];
  mainBaseArray = [];
  titleArrayForKeywords = [];
  
  ticketToken: string;
  FileDataURL: string;  
  subCategory: string;
  mainCategory: string;
  subcategoryId: string;
  categoryTitles: string;  
  selectedFileExtension: string = '';
  selectedSecondCategoryValue: string;
  selectedFirstCategoryValue: string;

  showFaq = false;
  showMore = false;
  fileSizeError = false;
  isFileUploaded = false;
  isButtonDisabled = false;
  showSecondaryCategory = false;
  formSubmitted = false;
  
  baseState: any;  

  constructor(
    @Inject(APP_SETTINGS) private settings: AppSettings,
    @Inject(PLATFORM_ID) private platformId: Object,
    private http: HttpClient,
    private fb: FormBuilder,
    private encryptionService: EncryptionService,
    private forumApiService: ForumApiService,
    private storageService: StorageService,
    private router: Router,
    private location: Location,
    private meta: Meta,
    private _bottomSheet: MatBottomSheet,
    private globalValueService: GlobalValueService,
    private titleService: Title,
    private route: ActivatedRoute,
    private dataService: DataService,
    private constantService: ConstantService
  ) {
    const navigation = this.router.getCurrentNavigation();
    this.baseState = navigation ? navigation.extras.state : null;
  }
  
  floatLabelControl = new FormControl('always');

  createTicketForm = this.fb.group({
    subject: [null, Validators.required],
    issueDescription: [null, Validators.required],
    category: [null, Validators.required],
    subCategory: [null]
  });

  ngOnInit(): void {
    this.knowledgeBase();
    this.addMetaTag();
    this.getValues();
    this.titleService.setTitle(this.constantService.createTicketPageTitle);
  }

  get f() {
    return this.createTicketForm.controls;
  }

  isFieldInvalid(fieldName: string): boolean {
    const control = this.createTicketForm.get(fieldName);
    return !!(control?.invalid && (control.touched || this.formSubmitted));
  }

  getValues(): { mainCategoryValue: string; subCategoryValue: string } {
    return {
      mainCategoryValue: this.globalValueService.mainCategory,
      subCategoryValue: this.globalValueService.subCategory
    };
  }

  addMetaTag(): void {
    try {
      this.meta.updateTag({ name: this.constantService.robots, content: this.constantService.createTicketPageRobotContent });
    } catch(e){
      console.log('Error in addMetaTag method - ',e);
    }
  }

  omit_special_char(event)
  {   
    try {
      var k;  
      k = event.charCode;
      return((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || k == 46 ||  (k >= 48 && k <= 57)); 
    } catch (e) {
      console.log('Error in omit special char method - ', e);
      return false;
    }    
  }

  async knowledgeBase(): Promise<void> {
    try {
      this.showSecondaryCategory = false;
      const portalId = this.encryptionService.decryptUsingAES_256(this.storageService.getItem(this.constantService.portalId));
      const include = this.constantService.knowledgeBaseRequestInclude;
      await this.forumApiService.knowledgeBase(include, portalId).then(async (knowledgeBaseResponse) => {
        const values = this.getValues();
        for(let i=0; i<knowledgeBaseResponse.child.length; i++){
           this.mainBaseArray[i] = knowledgeBaseResponse.child[i];
            this.categoryTitles = this.categoryTitles==undefined?"":this.categoryTitles + " " + knowledgeBaseResponse.child[i].name;
            this.titleArrayForKeywords[i] = knowledgeBaseResponse.child[i].name;
            this.meta.updateTag({ name: this.constantService.description, content: this.categoryTitles});
        }

        for(let j=0; j<knowledgeBaseResponse.child.length; j++){
          if(this.baseState?.isFromAnswers == this.constantService.yes && this.mainBaseArray[j].id == values.mainCategoryValue){
            this.createTicketForm.controls.category.setValue(this.mainBaseArray[j].name);
            this.showChild(this.mainBaseArray[j].name);
          }
        }

        var str = this.titleArrayForKeywords.join(", ");
        this.meta.updateTag({ name: this.constantService.keywords, content: str });        

      });
    } catch (e) {
      console.group('Error Occured in knowledgeBase : ', e);
    }
  }

  showChild(itemName: string): void  {
    try{
      const values = this.getValues();
      for(let j=0; j<this.mainBaseArray.length; j++){
        if(this.mainBaseArray[j].child.length != 0){
          if(itemName == this.mainBaseArray[j].name){
            this.createTicketForm.controls.subCategory.setValidators(Validators.required);        
            this.createTicketForm.controls.subCategory.updateValueAndValidity();
            this.showSecondaryCategory = true;
            this.childArray = this.mainBaseArray[j].child;
            break;
          }
        } 
        else {
          this.createTicketForm.controls.subCategory.clearValidators();
          this.createTicketForm.controls.subCategory.updateValueAndValidity();
          this.showSecondaryCategory = false;
        }
      }

      if(this.baseState.isFromAnswers == this.constantService.yes) {
        for(let k=0; k < this.childArray.length; k++) {
          if(this.childArray[k].id == values.subCategoryValue && this.showSecondaryCategory == true){
            this.createTicketForm.controls.subCategory.setValue(this.childArray[k].name);
            this.frequentlyAskedQuestions(this.childArray[k].id);
          }
        }
      }

    } catch(e){
      console.log('Error in showChild method');
    }    
  }
  
  selectFirstCategory(selectedValue: string): void {
    try {
      this.selectedFirstCategoryValue = selectedValue;
      this.faqArray = [];   
      this.showFaq = false; 
    } catch(e){
      console.log('Error in selectFirstCategory method - ', e);
    }   
  }

  selectSecondCategory(selectedValue: string): void {
    try {
      this.selectedSecondCategoryValue = selectedValue;
    } catch(e){
      console.log('Error in selectSecondCategory method - ', e);
    }
  }

  async frequentlyAskedQuestions(id: string): Promise<void>  {
    try {
      this.subcategoryId = id;
      this.faqArray = [];
      const portalId = this.encryptionService.decryptUsingAES_256(this.storageService.getItem(this.constantService.portalId));
      const categoryId = id;
      const from = this.constantService.faqRequestConstant.faqFrom;
      const limit = this.constantService.faqRequestConstant.faqLimitMax;
      const sortBy = this.constantService.faqRequestConstant.faqSortByLike;
      const locale = this.constantService.faqRequestConstant.faqlocale;
    
      await this.forumApiService.frequentlyAskedQuestions(portalId, categoryId, from, limit, sortBy, locale).then(async (faqResponse) => {
        const faqArr = [];
        for(let i=0; i<faqResponse.data.length; i++){
          faqArr[i] = faqResponse.data[i];
          this.faqArray = faqArr.slice(0, 5); 
        }

        if(this.faqArray.length > 0){
          this.showFaq = true;
          if(this.baseState?.isFromAnswers != this.constantService.yes) {
            setTimeout(() => {
              this.scrollToBottom();
            });
          }

        }else {
          this.showFaq = false;
        }
        
        if(faqArr.length > 5){
          this.showMore = true;
        }
        else {
          this.showMore = false;
        }
      });
    } catch (e) {
      console.log('Error Occured in frequentlyAskedQuestions : ', e);
    }    
  }

  goTosubCategoryAnswers(questionId: string, questionTitle: string, catId: string): void {
    try {
      this.dataService.data.subscribe((mainCategoryArray) => {
        mainCategoryArray.forEach(mainCat => {
          mainCat.child.forEach(subCat => {
            if(subCat.id == catId){
              this.mainCategory = mainCat.permalink;
              this.subCategory = subCat.permalink;
            }
          });
        });
      });
      this.router.navigate([this.mainCategory + '/' + this.subCategory + '/' + questionTitle], {queryParams: { questionId }});
    } catch(e){
      console.log('Error in goTosubCategoryAnswers method - ', e);
    }
  }

  onFaqKeydown(event: KeyboardEvent, questionId: string, questionTitle: string, catId: string): void {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.goTosubCategoryAnswers(questionId, questionTitle, catId);
    }
  }

  onFileSelected(event: any): void {
    try {
      let selectedFile = event.target.files[0];
      
      if (!selectedFile) {
        console.error('No file selected');
        return;
      }
      
      const fileName = selectedFile.name;
      const fileExtension = fileName.substring(fileName.lastIndexOf('.')).toLowerCase();
      const allowedExtensions = [".pdf", ".jpg", ".png", ".csv", ".xls", ".xlsx", ".docx", ".doc", ".ods"];
      
      if (!allowedExtensions.includes(fileExtension)) {
        console.error('Invalid file type:', fileExtension);
        this.isFileUploaded = false;
        return;
      }
      
      // Store the file extension for later use
      this.selectedFileExtension = fileExtension;
      
      if (selectedFile.size > 5 * 1024 * 1024) {
        this.fileSizeError = true;
        this.isFileUploaded = false;
        return;
      } else {
        this.fileSizeError = false;
      }
      
      this.readFileAsDataURL(selectedFile);
    } catch(e){
      console.log('Error in onFileSelected method - ', e);
    }
  }

  private readFileAsDataURL(file: File): void {
    try {
      const reader = new FileReader();

      reader.onload = (event) => {
        this.FileDataURL = reader.result as string;
        const indexOfFirstComma = this.FileDataURL.indexOf(',');
        if (indexOfFirstComma !== -1) {
          this.FileDataURL = this.FileDataURL.slice(indexOfFirstComma + 1);
        }      
        this.isFileUploaded = true;
      };
  
      reader.onerror = (error) => {
        this.isFileUploaded = false;
        console.error('Error reading file:', error);
      };
      reader.readAsDataURL(file);
    } catch(e){
      console.log('Error in readFileAsDataURL method - ', e);
    }
  }

  async createToken(): Promise<void> {
    try {
      this.isButtonDisabled = true;
      const request = {
        'RequestId' : this.encryptionService.decryptUsingAES_256(this.storageService.getItem(this.constantService.clientCode))
      }
      await this.forumApiService.createToken(request).then(async (createTokenResponse) => {
        if (createTokenResponse.statusCode === '0') {
            this.ticketToken = createTokenResponse.access_token;
            this.ticketGeneration(this.ticketToken);
        } else {
          this.createTicketForm.reset();
          this.isButtonDisabled = false;
        }
      });
    } catch (e) {
      this.isButtonDisabled = false;
      console.log('Error Occured in createToken : ', e);
    }
  }

  async ticketGeneration(tokenId: any): Promise<void> {
    try {
      const request =
        {
          Parameters: {
              subject: this.createTicketForm.value.subject,
              'Client Code': this.encryptionService.decryptUsingAES_256(this.storageService.getItem(this.constantService.clientCode)),
              channel:"Web",
              category: this.selectedFirstCategoryValue.replace(/[^a-zA-Z\s]/g, ' '),
              subCategory: this.selectedSecondCategoryValue.replace(/[^a-zA-Z\s]/g, ' '),
              description: this.createTicketForm.value.issueDescription
            },
            Attachment: this.FileDataURL ? this.encryptionService.encryptAttachment(this.FileDataURL) : '',
            AttachmentName: this.FileDataURL ? this.createTicketForm.value.subject + this.selectedFileExtension : ''
      }      
      
      await this.forumApiService.ticketGeneration(request, tokenId).then(async (ticketGenerationResponse) => {
        console.log('ticketGenerationResponse : ', ticketGenerationResponse);
        
        if(ticketGenerationResponse.Head.Description == this.constantService.success){
          this._bottomSheet.open(BottomsheetModalComponent, { hasBackdrop : false ,
            data: { message: this.constantService.bottomSheetModalMessages.success, ticketNumber: ticketGenerationResponse.Body.Ticketnumber }
          });
        } else {
          this._bottomSheet.open(BottomsheetModalComponent, {
            data: { message: this.constantService.bottomSheetModalMessages.failed }
          });
        }
        this.createTicketForm.reset();
      });
    } catch (e) {
      console.log('Error Occured in ticketGeneration : ', e);
    }
  }
  
  scrollToBottom(): void {
    try {
      if (isPlatformBrowser(this.platformId)) {
        window.scrollTo({
          top: document.body.scrollHeight,
          behavior: 'smooth'
        });
      }
    } catch(e){
      console.log('Error in scrollToBottom method - ', e);
    }
  }

  // goBack(): void {
  //   try {
  //     this.location.back();
  //   } catch(e){
  //     console.log('Error in goBack method - ', e);
  //   }
  // }

  goToSubCategory(): void{
    try {
      if(this.createTicketForm.controls.category.value != null && this.createTicketForm.controls.subCategory.value != null) {
        this.selectedSecondCategoryValue = this.createTicketForm.controls.subCategory.value;
      }
      this.dataService.data.subscribe((mainCategoryArray) => {
        mainCategoryArray.forEach(mainCat => {
          mainCat.child.forEach(subCat => {
            if(subCat.name == this.selectedSecondCategoryValue){
              this.mainCategory = mainCat.permalink;
              this.subCategory = subCat.permalink;
            }
          });
        });
      });

      this.router.navigateByUrl(this.mainCategory + '/' + this.subCategory);
    } catch(e){
      console.log('Error in goToSubCategory method - ', e);
    }
  }

  checkValidationAndCreateTicket(): void {
    try {
      this.formSubmitted = true;
      this.createTicketForm.markAllAsTouched();

      if(this.createTicketForm.invalid){
        this.focusFirstInvalidField();
        return;
      }
      this.createToken();
    } catch(e){
      console.log('Error in checkValidationAndCreateTicket method - ', e);
    }
  }

  private focusFirstInvalidField(): void {
    const fieldOrder = ['category', 'subCategory', 'subject', 'issueDescription'];
    for (const fieldName of fieldOrder) {
      const control = this.createTicketForm.get(fieldName);
      if (control?.invalid) {
        const element = document.querySelector(`[formcontrolname="${fieldName}"]`) as HTMLElement;
        element?.focus();
        break;
      }
    }
  }
  
}